import z from 'zod'

export const GetTransportRegistrationPlatesSchema = z.object({
  trailer: z.string().nullish(),
  truck: z.string().nullish(),
})

export const GetTransportSchema = z.object({
  driver_email: z.email().nullish(),
  driver_name: z.string().nullish(),
  driver_phone: z.string().nullish(),
  driver_phone_country: z.string().nullish(),
  truck_notes: z.string().nullish(),
})
